import { tablist } from 'clic-clac';
import 'tiny-slider';
import { tns } from 'node_modules/tiny-slider/src/tiny-slider';
import imageRatios from 'image-ratios';
import svg4everybody from 'svg4everybody';
import './sticky';
import 'fg-loadcss/src/cssrelpreload';
import './jobsfair';
import './notice';
import './sav';
import './purchase';

// exposing jquery globally
window.jQuery = jQuery;

const carouselSlider = tns({
    container: '.tiny-slider__inner',
    slideBy: 'page',
    loop: true,
    items: 1,
    lazyload: true,
    controls: false,
    nav: true,
    autoHeight: true,
    mouseDrag: true,
    responsive: {
      1200: {
        mouseDrag: false
      }
    },
    touch: true,
    startIndex: 1,
    speed: 400,
    autoplay: true
});

imageRatios();

$('.tiny-slider__controls--next > svg').on('click', () => {
    carouselSlider.goTo('next');
});
$('.tiny-slider__controls--prev > svg').on('click', () => {
    carouselSlider.goTo('prev');
});

jQuery($ => {
    function setMenuPosition(elementMenu) {
    if (elementMenu.length === 0) {
        return;
    }
    const data_tab_for = elementMenu.attr('data-tab-for');
    const position = elementMenu.offset();

    $(`#${data_tab_for} > ul`).css('margin-left', position.left);
}

$('.header__n1-entry button[role="tab"]').on('click', function() {
    console.log('click');
    setMenuPosition($(this));
});

$(window).resize(() => {
    const menu_item_selected = $(
        '.header__navigation li[aria-selected="true"]'
    );

if (menu_item_selected) {
    setMenuPosition(menu_item_selected);
}
});

$('[data-display-image-hook] > ul > li > ul > li > a').mouseenter(function() {
    $('.header__navigation-panel-img').css('display', 'inline-block');
    $('.header__navigation-panel-img > img').attr(
        'src',
        $(this).attr('data-src')
    );
    $('.header__navigation-panel-img > span').html($(this).attr('data-name'));
    $('.header__navigation-panel-img > a').attr('href', $(this).attr('href'));
});

$('[data-display-image-hook]').mouseleave(() => {
    $('.header__navigation-panel-img').css('display', 'none');
});

/*
 * $('.header__burger').on('click', function(){
 * 	$('.header__navigation-mobile').slideToggle('slow');
 * });
 * $('.header__navigation-mobile a').on('click', function(){
 * 	$(this).next('ul').slideToggle('slow');
 * });
 */
});

$('[data-jquery-expand]').on('clic-clac-state-update', ({ detail }) => {
    if ($(detail.element).attr('aria-expanded') === 'true') {
    $(detail.element).slideDown(500);
}
else {
    $(detail.element).slideUp(500);
}
});

// TEMP !!!!
$('[data-product-menu]').each((index, item) => {
    const productMenuID = `product-menu-${index}`;

$(item)
    .attr('id', productMenuID)
    .attr('data-tablist', '');

$(item)
    .find('> li > a')
    .each((linkIndex, link) => {
    const contentID = `${productMenuID}-controlled-${linkIndex}`;

$(link)
    .next()
    .attr('id', contentID)
    .attr('data-jquery-expand', 'true')
    .closest('li')
    .find('> a')
    .attr('data-tab-for', contentID)
    .attr('data-owner', productMenuID);
});

tablist.addTablist(item);
});

(function(win, $) {
    $.getScript('https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyB1P85Jbgu6tAt9P69WxQWnGpJSBP0__84')
        .done(function() {
            win.MapGooglePurchase.initialize();
        });
})(window, jQuery);

svg4everybody();



// WEBPACK FOOTER //
// ../work/src/js/body.js